/** Navigation structure matching the Svelte +layout.svelte */
export const navSections = [
  {
    id: 'shop',
    label: 'Shop Now',
    dropdownRight: false,
    links: [
      { href: 'https://www.bluecompassrv.com/new-rvs-for-sale', label: 'New RVs' },
      { href: 'https://www.bluecompassrv.com/used-rvs-for-sale', label: 'Used RVs' },
      { href: 'https://www.bluecompassrv.com/product/towables', label: 'Shop Towables' },
      { href: 'https://www.bluecompassrv.com/product/motor-home', label: 'Shop Motorized' },
      { href: 'https://www.bluecompassrv.com/new-airstreams-for-sale', label: 'New Airstreams' },
      { href: 'https://www.bluecompassrv.com/rv-specials', label: 'RV Specials' },
    ],
  },
  {
    id: 'sell',
    label: 'Sell My RV',
    dropdownRight: false,
    lgOnly: true,
    links: [
      { href: 'https://www.bluecompassrv.com/value-your-trade', label: 'Value Your Trade' },
      { href: 'https://www.bluecompassrv.com/sell-my-rv', label: 'Sell My Rv' },
      { href: 'https://www.bluecompassrv.com/rv-consignment', label: 'Cosign My RV' },
    ],
  },
  {
    id: 'financing',
    label: 'Financing',
    dropdownRight: false,
    lgOnly: true,
    links: [
      { href: 'https://www.bluecompassrv.com/rv-financing', label: 'RV Financing' },
      { href: 'https://www.rvcomplete.com/', label: 'RV Complete' },
    ],
  },
  {
    id: 'parts',
    label: 'Parts & Service',
    dropdownRight: false,
    links: [
      { href: 'https://www.bluecompassrv.com/rv-parts', label: 'RV Parts' },
      { href: 'https://www.bluecompassrv.com/rv-service', label: 'RV Service' },
      { href: 'https://www.bluecompassrv.com/service-specials', label: 'Service Specials' },
      { href: 'https://www.rvcomplete.com/', label: 'RV Complete' },
    ],
  },
  {
    id: 'about',
    label: 'About',
    dropdownRight: true,
    lgOnly: true,
    links: [
      { href: 'https://www.bluecompassrv.com/about-us', label: 'About' },
      { href: 'https://www.bluecompassrv.com/reviews', label: 'Reviews' },
      { href: 'https://www.bluecompassrv.com/submit-review', label: 'Leave a Review' },
      { href: 'https://www.bluecompassrv.com/blog/', label: 'Blog' },
      { href: 'https://www.bluecompassrv.com/blog/category/in-the-news/', label: 'In the News' },
      { href: 'https://www.bluecompassrvcareers.com/', label: 'Careers' },
      { href: 'https://bluecompassrvretail.itemorder.com/shop/home/', label: 'Apparel' },
      { href: 'https://www.bluecompassrv.com/acquisitions', label: 'Acquisitions' },
    ],
  },
];

export const footerLinks = [
  { href: 'https://www.bluecompassrv.com/rvs-for-sale', label: 'Shop Now' },
  { href: 'https://www.bluecompassrv.com/sell-my-rv', label: 'Sell My RV' },
  { href: 'https://www.bluecompassrv.com/rv-financing', label: 'Financing' },
  { href: 'https://www.bluecompassrv.com/rv-service', label: 'Parts & Service' },
  { href: 'https://www.bluecompassrv.com/about-us', label: 'About' },
];
